export function getUserNamefromId(license,userId){
    if(license){
        return ( license.users.find(x=>x.id===userId)).name
    }
    return userId
}